import { z } from 'zod';
import { Email, Password } from './auth.js';
/**
 * Password reset and email verification (plan §5, extended).
 *
 * The forgot endpoint deliberately answers the same way whether or not the address is
 * registered — a "no such account" here would be a free user-enumeration oracle, and the
 * person who typed the address wrongly is helped no more by being told.
 */
export const ForgotPasswordRequest = z.object({
    email: Email,
});
export const ResetPasswordRequest = z.object({
    token: z.string().min(1).max(256),
    password: Password,
});
export const VerifyEmailRequest = z.object({
    token: z.string().min(1).max(256),
});
/** What the caller is told after asking for a reset — the same, always. */
export const ForgotPasswordResponse = z.object({
    /** Present only when no provider is configured, so local development is not a dead end. */
    devLink: z.string().nullable().optional(),
});
//# sourceMappingURL=password.js.map